import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import expertDefaultImg from "../../images/expert-default.png";
import SendInmail from "./SendInmail";
import SendEmail from "../ListDetails/SendEmail";
import LoadingIcon from "../../images/Loading_icon.gif";
// import SendUndo from './SendUndo';
import EditProfileBasic from "./EditProfileBasic";
import ExAvailabilityComment from "./ExAvailabilityComment";
import ExExperience from "./ExExperience";
import ExHourlyRate from "./ExHourlyRate";
import ExDailyRate from "./ExDailyRate";
import ExPhoneNumber from "./ExPhoneNumber";
import ProjectExpertStatus from "./ProjectExpertStatus";
import ProjectExpertType from "./ProjectExpertType";
import ExShortProfile from "./ExShortProfile";
import ProjectExpertIsVip from "./ProjectExpertIsVip";
import ExZohoBtn from "./ExZohoBtn";
import ExMaxWorkingDays from "./ExMaxWorkingDays";
import ProjectExpertDelete from "./ProjectExpertDelete";
import ExSummary from "./ExSummary";
import ExContactedDate from "./ExContactedDate";
import ExCreateDigitalPPT from "./ExCreateDigitalPPT";
import ExAddedDate from "./ExAddedDate";
import ExAvailabilityDate from "./ExAvailabilityDate";
import ConnectionBtn from "./ConnectionBtn";
// import ExContactLog from './ExContactLog';
import ExEmailChange from "./ExEmailChange";
import ExLastContact from "./ExLastContact";
import ContactListForList from "./ContactListForList";
// import AddToProject from "./AddToProject";
import AddToProject from "../ExpertDetails/AddToProject";
import { ListDetailsContext } from "../../contexts/ListDetailsContext";

export default function ProjectExpertRow({
  data,
  project_id,
  appendExpertId,
  removeExpertId,
  project_name,
  project,
  titleCount,
  setTitleCount,
  filterCount,
  setEmailButtonClicked,
  setSelectedConsulData,
  setEmailDetails,
  setComposeEmail,
  fieldsLoading,
}) {
  const [exObject, setExObject] = useState({
    expertName: "",
    expertLink: "",
    expertEmail: "",
  });
  const [partiallyAvailable, setPartiallyAvailable] = useState(false);
  const [availablityDate, setAvailablityDate] = useState(null);
  const [availabiltyBorder, setAvailabiltyBorder] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [summLength, setSummLength] = useState(0);
  const [showSummAlert, setShowSummAlert] = useState(false);
  const [availabilityComment, setAvailabilityComment] = useState(null);
  const [showComment, setShowComment] = useState(false);
  const [exContactedBy, setExContactedBy] = useState(null);
  const [exContactedMethod, setExContactedMethod] = useState(null);
  const [exDateCreated, setExDateCreated] = useState(null);
  const [emailCount, setEmailCount] = useState(0);
  const { tableData, setTableData } = useContext(ListDetailsContext);

  useEffect(() => {
    setNewStatus(data?.expertStatus);
    setExContactedBy(data?.expert.contacted_by);
    setExContactedMethod(data?.expert.mail_inmail);
    setExDateCreated(data?.expert.Date_Created);
  }, [data]);

  const updateProfileData = (exObject) => {
    setExObject(exObject);
  };
  useEffect(() => {
    if (data) {
      setAvailablityDate(data.expert.Available_from);
      setAvailabilityComment(data.expert.Available_comment);
      setExObject({
        expertName: data.expert.Name,
        expertLink: data.expert.link,
        expertEmail: data.expert.email,
      });
    }
  }, [data]);

  useEffect(() => {
    if (availablityDate) {
      const today = new Date();
      const availDate = new Date(availablityDate);
      if (
        availablityDate === "Wed, 01 Jan 2020 00:00:00 GMT" ||
        availablityDate === "Fri, 01 Jan 2010 00:00:00 GMT"
      ) {
        setAvailabiltyBorder("");
      } else if (availDate < today) {
        setAvailabiltyBorder("prjdetails-con-img-green");
      } else if (availDate > today) {
        setAvailabiltyBorder("prjdetails-con-img-red");
      }
    }
  }, [availablityDate]);

  return (
    <div className="prjdetails-table-row">
      {!fieldsLoading ? (
        <>
          <div className="prjdetails-row-top">
            <input
              className="single-checkbox"
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  appendExpertId(data.expert.ID);
                } else {
                  removeExpertId(data.expert.ID);
                }
              }}
            />
            <div className="row-left-top-div">
              <div className="con-image-div">
                <a
                  href={`/app/ExpertDetails/${data.expert.ID}`}
                  className="prjdetails-eph-profile"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className={`prjdetails-con-img ${availabiltyBorder}`}
                    src={
                      data.expert.profilePicture
                        ? data.expert.profilePicture
                        : expertDefaultImg
                    }
                    alt=""
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = expertDefaultImg;
                    }}
                  />
                </a>
                <div className="name-con-expert-div">
                  <a
                    className="prjdetails-con-name"
                    href={exObject.expertLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {exObject.expertName}
                  </a>
                  <div className="position-relative">
                    <ProjectExpertType
                      type={data?.expert.cons_exp}
                      expert_id={data?.expert.ID}
                    />
                    <EditProfileBasic
                      expert_id={data?.expert.ID}
                      expert_Name={exObject.expertName}
                      expert_link={exObject.expertLink}
                      expert_email={exObject.expertEmail}
                      updateProfileData={updateProfileData}
                    />
                  </div>
                </div>
                <ProjectExpertIsVip
                  isVip={data?.expert.isVip}
                  expert_id={data?.expert.ID}
                />
              </div>
              <div className="left-bottom-phone position-relative">
                <i
                  className="fa-regular fa-envelope"
                  style={{ marginRight: "1px", fontSize: "16px" }}
                />
                <ExEmailChange
                  email={exObject.expertEmail}
                  expert_id={data?.expert.ID}
                  exObject={exObject}
                  setExObject={setExObject}
                />
              </div>
              <div className="left-bottom-phone position-relative">
                <i
                  className="fa-solid fa-phone"
                  style={{ marginRight: "2px" }}
                />
                <ExPhoneNumber
                  phone={data?.expert.phone_n}
                  expert_id={data?.expert.ID}
                />
              </div>{" "}
              <div className="left-bottom-hourly position-relative">
                <i className="fa-solid fa-money-bill-1" title="Hourly rate" />
                <ExHourlyRate
                  hourlyRate={data?.expert.hourly_rate}
                  hourlyRateCurrency={data?.expert.hourly_rate_currency}
                  expert_id={data?.expert.ID}
                />
              </div>
              <div className="left-bottom-daily position-relative">
                <i className="fa-solid fa-money-bill" title="Daily rate" />
                <ExDailyRate
                  dailyRate={data?.expert.daily_rate}
                  dailyRateCurrency={data?.expert.daily_rate_currency}
                  expert_id={data?.expert.ID}
                />
              </div>{" "}
            </div>
            <div style={{ display: "inline-flex" }}>
              <div className="prjdetails-panel prjdetails-third-panel">
                <div className="prjdetails-panel-body pn">
                  <table className="table prjdetails-second-section mbn tc-icon-1 tc-med-2 tc-bold-last">
                    <tbody>
                      <tr>
                        <td className="position-relative">
                          <ExSummary
                            summary={data?.expert.summ}
                            expert_id={data?.expert.ID}
                            summLength={summLength}
                            setSummLength={setSummLength}
                            showSummAlert={showSummAlert}
                            setShowSummAlert={setShowSummAlert}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="position-relative">
                          <ExExperience
                            experience={data?.expert.experience}
                            expert_id={data?.expert.ID}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="position-relative">
                          <ExShortProfile
                            shortProfile={data?.expert.eph_short}
                            expert_id={data?.expert.ID}
                          />
                        </td>
                      </tr>
                      {partiallyAvailable && (
                        <tr>
                          <td className="position-relative">
                            <ExMaxWorkingDays
                              maxWork={data?.expert.max_working_days}
                              expert_id={data?.expert.ID}
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* <div className="prjdetails-panel prjdetails-profile-status">
            <div className="prjdetails-status-div">
               <ProjectExpertStatus 
                  status={data?.expertStatus}
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                  setPartiallyAvailable={setPartiallyAvailable}
                  setNewStatus={setNewStatus}
                  backupData={backupData}
                  setBackupData={setBackupData}
               />
            </div>
         </div> */}

            <div className="prjdetails-panel prjdetails-action-btn">
              <div className="prjdetails-btns-div position-relative">
                <SendEmail
                  expert={data?.expert}
                  // backupData={tableData}
                  // setBackupData={setTableData}
                  project_id={project_id}
                  project_name={project_name}
                  emailCount={emailCount}
                  // setExContactedBy={setExContactedBy}
                  // setExContactedMethod={setExContactedMethod}
                  setEmailCount={setEmailCount}
                  exObject={exObject}
                  // setEmailButtonClicked={setEmailButtonClicked}
                  // setSelectedConsulData={setSelectedConsulData}
                  setEmailDetails={setEmailDetails}
                  setComposeEmail={setComposeEmail}
                  // setExDateCreated={setExDateCreated}
                />
                {/* <SendInmail
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                /> */}
                {/* <SendUndo expert_id={data?.expert.ID} project_id={project_id} /> */}
                {/* <ConnectionBtn
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                /> */}
              </div>
            </div>

            <div className="prjdetails-panel prjdetails-action-btn">
              <div className="prjdetails-btns-div position-relative">
                <ExZohoBtn
                  expert_id={data?.expert.ID}
                  in_zoho={data?.expert.in_zoho}
                  status={newStatus}
                  summLength={summLength}
                  setShowSummAlert={setShowSummAlert}
                  exObject={exObject}
                  project_id={project_id}
                />
                <AddToProject
                  expertID={data?.expert.ID}
                  btnName={" Add to project"}
                />
                <ExCreateDigitalPPT
                  digitalExist={data?.digitalExist}
                  pptExist={data?.expert.pptExist}
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                  project={project}
                  expertName={data?.expert.Name}
                  digitalPowerPointList={data?.expert.digitalPowerPointList}
                  titleCount={titleCount}
                  setTitleCount={setTitleCount}
                />

                <Link
                  to={`/app/SimilarProfilesForList/${project_id}/${data.expert.ID}`}
                >
                  <button className="btn">
                    <i className="fa-solid fa-users-viewfinder" /> Similar
                    Profiles
                  </button>
                </Link>
              </div>
            </div>
          </div>{" "}
        </>
      ) : (
        <div className="prjdetails-row-top" style={{ height: "180px" }}></div>
      )}
      <div className="prjdetails-row-bottom">
        <div style={{ float: "left", marginLeft: "11px" }}>
          {showComment && (
            <ExAvailabilityComment
              comment={availabilityComment}
              expert_id={data?.expert.ID}
              setAvailabilityComment={setAvailabilityComment}
            />
          )}
          <div className="topCon-available-date">
            <i
              className="calender-icon fa-regular fa-calendar-days"
              style={{ marginRight: "11px" }}
            ></i>
            <label>Availability</label>
            <i
              className={
                availabilityComment
                  ? "comment-icon fa-regular fa-comment-dots"
                  : "comment-icon comment-empty fa-regular fa-comment-dots"
              }
              onClick={() => setShowComment(!showComment)}
              title="Click to see comment"
              style={{ left: "98px" }}
            ></i>
            <ExAvailabilityDate
              date={data?.expert.Available_from}
              expertID={data?.expert.ID}
              setAvailablityDate={setAvailablityDate}
            />
          </div>
        </div>
        <div className="prjdetails-bottom-right">
          <ExLastContact
            addedTime={data.expert.Date_Created}
            contactMethod={data.expert.mail_inmail}
            contactedBy={data.expert.contacted_by}
            savedBy={data.expert.saved_by}
          />
          <ContactListForList expertID={data.expert.ID} />
          <div className="pjcon-added-at">
            <i className="fa-regular fa-calendar-plus" />
            <ExAddedDate
              addedTime={data?.expertAdded}
              addedBy={data?.expertAddedBy}
            />
          </div>
          <ProjectExpertDelete
            expert_id={data?.expert.ID}
            project_id={project_id}
          />
        </div>
      </div>
    </div>
  );
}
